export enum actionTypes {
  GET_AVISO = 'GET_AVISO',
  GET_AVISO_SUCCESS = 'GET_AVISO_SUCCESS',
  GET_AVISO_ERROR = 'GET_AVISO_ERROR',
  GET_AVISO_RESET = 'GET_AVISO_RESET',
}

export enum AvisoStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Aviso {
  id: number
  idPais: number
  tipo: string
  estado: string
  titulo: string
  fechaFinalizacion: string
  links: [
    {
      rel: string
      href: string
    }
  ]
  totalPostulaciones: string
  totalCurriculumsSinLeer: string
  origenBumi: boolean
}

export interface AvisoState {
  aviso: Aviso[] | null
  status: AvisoStatus
}

export const initialState: AvisoState = {
  aviso: null,
  status: AvisoStatus.Idle,
}

export interface GetAviso {
  type: typeof actionTypes.GET_AVISO
  payload: null
}

export interface GetAvisoSuccess {
  type: typeof actionTypes.GET_AVISO_SUCCESS
  payload: Aviso[]
}

export interface GetAvisoError {
  type: typeof actionTypes.GET_AVISO_ERROR
  payload: boolean
}

export interface GetAvisoReset {
  type: typeof actionTypes.GET_AVISO_RESET
  payload: null
}

export type AvisoActions = GetAviso | GetAvisoSuccess | GetAvisoError | GetAvisoReset
